// Module
var code = "<ngx-library-collection-viewer [filter-type]=\"$ctrl.filterType\" [mode]=\"$ctrl.mode\" [previewable]=\"$ctrl.previewable\" [collection-management]=\"$ctrl.collectionManagement\" (select-item)=\"$ctrl.selectItem($event.item)\"></ngx-library-collection-viewer>";
// Exports
module.exports = code;